import { Injectable, signal } from "@angular/core";
import { CacheId } from "@shared/enums";
import { JwtToken } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  offline = signal<boolean>(false);
  isApaApp = signal<boolean>(false);
  authedToken = signal<JwtToken>({} as JwtToken);
  theme = signal<string>("light");
  fontSize = signal<string>("medium");
  device = signal<string>("desktop");
  screenWidth = signal<number>(0);
  navbarHeight = signal<number>(52);
  activePlanUnsaved = signal<boolean>(false);
  standbyPlanUnsaved = signal<boolean>(false);
  saving = signal<boolean>(false);

  init(): void {
    this.checkforUnsavedData();
  }

  checkforUnsavedData(): void {
    const checkEdits = (key: CacheId, signal: any) => {
      const edits = localStorage.getItem(key);
      signal.set(edits ? JSON.parse(edits).length > 0 : false);
    };

    checkEdits(CacheId.ActivePlanEdits, this.activePlanUnsaved);
    checkEdits(CacheId.StandbyPlanEdits, this.standbyPlanUnsaved);
  }
}
